
import React from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Input } from '@/components/ui/input';

interface BookingFiltersProps {
  shopFilter: string;
  paymentFilter: string;
  dateFilter: string;
  shopNames: string[];
  onShopFilterChange: (value: string) => void;
  onPaymentFilterChange: (value: string) => void;
  onDateFilterChange: (value: string) => void;
}

const BookingFilters = ({
  shopFilter,
  paymentFilter,
  dateFilter,
  shopNames,
  onShopFilterChange,
  onPaymentFilterChange,
  onDateFilterChange
}: BookingFiltersProps) => {
  return (
    <div className="flex flex-col md:flex-row gap-4 mb-6">
      <div className="flex-1">
        <Select value={shopFilter} onValueChange={onShopFilterChange}>
          <SelectTrigger>
            <SelectValue placeholder="تصفية حسب الورشة" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">جميع الورش</SelectItem>
            {shopNames.map((shop) => (
              <SelectItem key={shop} value={shop}>
                {shop}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
      
      <div className="flex-1">
        <Select value={paymentFilter} onValueChange={onPaymentFilterChange}>
          <SelectTrigger>
            <SelectValue placeholder="تصفية حسب حالة الدفع" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">جميع الحالات</SelectItem>
            <SelectItem value="pending">قيد الانتظار</SelectItem>
            <SelectItem value="paid">مدفوع</SelectItem>
            <SelectItem value="failed">فشل</SelectItem>
          </SelectContent>
        </Select>
      </div>
      
      <div className="flex-1">
        <Input
          type="date"
          value={dateFilter}
          onChange={(e) => onDateFilterChange(e.target.value)}
          placeholder="تصفية حسب التاريخ"
        />
      </div>
    </div>
  );
};

export default BookingFilters;
